/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { NgModule } from '@angular/core';
import { SuppliersListComponent } from './suppliers/suppliers-list/suppliers-list.component';
import { SuppliersFormComponent } from './suppliers/suppliers-form/suppliers-form.component';
import { SuppliersRoutingModule } from '@app/suppliers/suppliers-routing.module';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared';

@NgModule({
  declarations: [SuppliersListComponent, SuppliersFormComponent],
  imports: [CommonModule, SuppliersRoutingModule, ReactiveFormsModule, SharedModule],
})
export class SuppliersModule {}
